import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';

import imageBG from './../../static/img/bg.jpg';
import MainHeader from './../main/MainHeader';
import MainFooter from './../main/MainFooter';

import Container from '@mui/material/Container';
import CardMedia from '@mui/material/CardMedia';

/**
 * View component to be use as root component, with header, footer, etc.
 */
class View extends React.Component {
  render () {
    const { classes, children, contentMaxWidth, classesRoot, classesContent, justifyContent, disableGutters, bgImage, headerTitle, hideHeader, hideFooter, headerLeft, headerRight, headerShortActions } = this.props;
    return (
      <Container disableGutters maxWidth={false} className={clsx(classes.root, classesRoot)}>
        { !hideHeader && (
          <MainHeader
            title={headerTitle}
            leftComponents={headerLeft}
            rightComponents={headerRight}
            shortActions={headerShortActions}
          />
        ) }
        { bgImage && (
          <CardMedia
            sx={{
              position: 'fixed',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            }}
            image={imageBG}
            title="image accueil"
          />
        ) }
        <Container disableGutters={disableGutters} maxWidth={ contentMaxWidth } className={clsx(classes.content, classesContent, {[classes.hasHeader]: !hideHeader}, {[classes.hasFooter]: !hideFooter}, {[classes.justifyContent]: justifyContent})}>
          { children }
        </Container>
        { !hideFooter && (
          <MainFooter />
        ) }
      </Container>
    )
  }
}

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.bg.light,
  },
  hasHeader: {
    paddingTop: theme.spacing(6.4),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(5.5),
    },
  },
  hasFooter: {
    paddingBottom: theme.spacing(6.4),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(5.5),
    },
  },
  content: {
    minHeight: '100vh',
  },
  justifyContent: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  }
});

View.propTypes = {
  disableGutters: PropTypes.bool,
  bgImage: PropTypes.bool,
  hideHeader: PropTypes.bool,
  hideFooter: PropTypes.bool,
  headerTitle: PropTypes.string,
  headerLeft: PropTypes.array,
  headerRight: PropTypes.array,
  contentMaxWidth: PropTypes.string,
  classesRoot: PropTypes.string,
  classesContent: PropTypes.string,
};

View.defaultProps = {
  disableGutters: false,
  bgImage: false,
  hideHeader: false,
  hideFooter: false,
  contentMaxWidth: 'sm',
};

export default withStyles(styles, { withTheme: true })(View);
